import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSidebarExpanded } from "../../features/configSlice";

import logo from "../../assets/logo1.png";
import {
  ChevronDown,
  ChevronLeft,
  CircleDot,
  Menu,
  MoreVertical,
  X,
} from "lucide-react";
import { NavLink } from "react-router-dom";

const SidebarTwo = ({ children, setOpen, expand }) => {
  const dispatch = useDispatch();
  const expanded = useSelector((state) => state.config.sidebarExpanded);

  useEffect(() => {
    if (expand) {
      dispatch(setSidebarExpanded(expand));
    }
  }, [expanded]);

  return (
    <aside className="h-full bg-content">
      <nav className="h-full flex flex-col">
        <div className="p-4 pb-2 flex justify-between items-center">
          <div
            className={`flex items-center gap-1 font-bold text-text-1 transition-all ${
              expanded ? "w-full" : "w-0 hidden"
            }`}
          >
            <img
              src={logo}
              alt="logo"
              className={`overflow-hidden transition-all ${
                expanded ? "w-8" : "w-0"
              }`}
            />
            Salesians of Don Bosco
          </div>
          <button
            onClick={() => dispatch(setSidebarExpanded(!expanded))}
            className="p-1.5 rounded-lg text-text-1 hover:bg-bkg2 hidden sm:block"
          >
            {expanded ? <Menu /> : <Menu />}
          </button>
          {/* Phone View Close */}
          <button
            onClick={() => setOpen(false)}
            className="p-1.5 rounded-lg text-text-1 hover:bg-bkg block sm:hidden"
          >
            <X />
          </button>
        </div>
        {/* Content */}
        <ul className="flex-1 px-3">{children}</ul>
        {/* Footer */}
        <div className="border-t border-bkg2 flex p-3">
          <img src={logo} alt="profile" className="h-8 w-8 rounded-md " />
          <div
            className={`flex justify-between items-center overflow-hidden transition-all ${
              expanded ? "w-52 ml-3 " : "w-0"
            } `}
          >
            <div className="leading-4">
              <h4 className="font-semibold">Don Bosco</h4>
              <span className="text-xs text-gray-600 hidden sm:inline">
                admin@donbosco.com
              </span>
            </div>
            <MoreVertical size={20} />
          </div>
        </div>
      </nav>
    </aside>
  );
};

export const SidebarItem = ({
  icon,
  text,
  children,
  alert,
  to,
  onClick,
  type,
}) => {
  const expanded = useSelector((state) => state.config.sidebarExpanded);
  const [openItem, setOpenItem] = useState(false);
  const menuRef = useRef();

  if (children) {
    children = children.filter((item) => item !== false);
  } else children = [];

  const handleNavClick = (e) => {
    if (type !== "link") {
      e.preventDefault();
    }
    setOpenItem(!openItem);
    if (type === "link" && onClick) {
      onClick();
    }
  };

  const handleSubItemClick = (e) => {
    setOpenItem(false);
    if (onClick) {
      onClick();
    }
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setOpenItem(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      setOpenItem(false);
    };
  }, []);

  return (
    <div
      className={`${type !== "link" ? "flex flex-col" : ""}  ${
        type !== "link" && children.length <= 0 ? "hidden" : ""
      }`}
    >
      <NavLink
        onClick={handleNavClick}
        className={({ isActive }) =>
          isActive && type === "link"
            ? `relative flex items-center py-2 px-3 my-1 font-medium rounded-md  cursor-pointer transition-colors group bg-gradient-to-tr from-bkg2/90 to-bkg2/100 text-text-1`
            : `relative flex items-center py-2 px-3 my-1 font-medium ${
                type !== "link" ? "cursor-default" : "cursor-pointer"
              } rounded-md transition-colors group hover:bg-bkg2 text-text-1`
        }
        to={type !== "link" ? null : to}
      >
        {icon}
        <span
          className={`overflow-hidden transition-all whitespace-nowrap ${
            expanded ? "w-52 ml-3" : "w-0"
          }`}
        >
          {text}
        </span>
        {type !== "link" && (
          <button
            onClick={handleNavClick}
            className={`absolute  rounded-md hover:bg-primary ${
              expanded
                ? "right-4 top-2 "
                : "-top-0.5 left-0 h-full w-full text-transparent bg-transparent hover:bg-transparent"
            }`}
          >
            {openItem ? <ChevronDown /> : <ChevronLeft />}
          </button>
        )}

        {!expanded && openItem && type !== "link" && (
          <div
            ref={menuRef}
            className={`absolute top-0 left-full rounded-md  ml-5 bg-content text-text-1/75 transition-all z-30 overflow-hidden border border-bkg2`}
          >
            {children.map((item, index) => {
              {
                return (
                  <SidebarSubItem
                    key={index + 1}
                    {...item.props}
                    onClick={handleSubItemClick}
                  />
                );
              }
            })}
          </div>
        )}

        {!expanded && (
          <div
            className={`absolute left-full rounded-md px-2 py-1 ml-6 bg-indigo-100 text-indigo-800 text-sm invisible opacity-20 -translate-x-3 transition-all group-hover:visible group-hover:opacity-100 group-hover:translate-x-0 z-20`}
          >
            {text}
          </div>
        )}
      </NavLink>

      {expanded && openItem && type !== "link" && (
        <div
          ref={menuRef}
          className="bg-content border border-bkg2 rounded-md overflow-hidden "
        >
          {children.map((item, index) => {
            {
              return (
                <SidebarSubItem
                  key={index + 1}
                  {...item.props}
                  onClick={handleSubItemClick}
                />
              );
            }
          })}
        </div>
      )}
    </div>
  );
};

export const SidebarSubItem = ({ text, to, onClick }) => {
  const expanded = useSelector((state) => state.config.sidebarExpanded);

  return (
    <NavLink
      onClick={onClick}
      to={to}
      className={`clicked flex justify-start items-center text-base text-text-1/75 hover:bg-bkg2 pr-8 gap-3 py-1  ${
        expanded ? "pl-14" : "pl-3 text-sm"
      } py-0.5 z-10`}
    >
      <CircleDot size={10} />
      <p className="inline-block text-text-1 whitespace-nowrap">{text}</p>
    </NavLink>
  );
};

export default SidebarTwo;
